import {
    Contract,
    DashboardMarketingCard,
    DashboardMarketingCards,
    PersonalDetails,
    TotalEarlySettlement,
    TotalEarlySettlementOfflinePayment,
} from 'cpes-common'; //ContactDetails,CustomerAddress,
import { Carousel } from '@cp-shared-19/frontend-ui';
import React, { useEffect, useState, memo } from 'react';
import { FlickityOptions } from 'react-flickity-component';
import { ExtendedWarrantyMarketingCard } from '../extended-warranty-marketing-card/ExtendedWarrantyMarketingCard';
import { MarketingCardComponent } from '../marketing-card-component';

type DashboardMarketingCardUiProps = {
    mostRecentSeatContract?: Contract;
    personalDetails?: PersonalDetails;
    dashboardMarketingCard?: DashboardMarketingCards;
    totalEarlySettelment?: TotalEarlySettlement;
    offlinePayment?: TotalEarlySettlementOfflinePayment;
    showLongDriveMarketingCard?: boolean;
    showMototrCarInsuranceCard?: boolean;
    setHasMarketingCard: (hasCard: boolean) => void;
};

export const DashboardMarketingCardUi: React.FC<DashboardMarketingCardUiProps> = memo(
    ({
        mostRecentSeatContract,
        personalDetails,
        dashboardMarketingCard,
        totalEarlySettelment,
        offlinePayment,
        showLongDriveMarketingCard,
        showMototrCarInsuranceCard,
        setHasMarketingCard,
    }) => {
        const [productRoutingLoaded, setProductRoutingLoaded] = useState<boolean>();
        const setProductRoutingOnLoad = (loadingSuccessful: boolean): void => {
            setProductRoutingLoaded(loadingSuccessful);
        };

        const getCarouselKey = (): string => (productRoutingLoaded ? mostRecentSeatContract?.contractNumber || '' : '');

        if (!dashboardMarketingCard) {
            return null;
        }

        const options: FlickityOptions = {
            autoPlay: 10000,
        };

        const cardsToRender = dashboardMarketingCard.filter((card: DashboardMarketingCard) => {
            if (card.flag === 'extendedWarranty') {
                return productRoutingLoaded || productRoutingLoaded === undefined;
            } else if (card.flag === 'longDrive' && !showLongDriveMarketingCard) {
                return false;
            } else if (card.flag === 'motorCarInsurance' && !showMototrCarInsuranceCard) {
                return false;
            } else {
                return true;
            }
        });

        useEffect(() => {
            setHasMarketingCard(cardsToRender.length > 0);
        }, [cardsToRender, setHasMarketingCard]);

        return (
            <>
                <Carousel options={options} key={getCarouselKey()}>
                    {cardsToRender.map((card: DashboardMarketingCard) => {
                        if (card.flag === 'extendedWarranty') {
                            return (
                                <ExtendedWarrantyMarketingCard
                                    personalDetails={personalDetails}
                                    dashboardMarketingCard={card}
                                    testId="extended-warranty"
                                    mostRecentSeatContract={mostRecentSeatContract}
                                    setProductRoutingLoaded={setProductRoutingOnLoad}
                                    totalEarlySettelment={totalEarlySettelment}
                                    offlinePayment={offlinePayment}
                                    key={card.title}
                                />
                            );
                        } else {
                            return (
                                <MarketingCardComponent
                                    testId="google-rating-card"
                                    content={card}
                                    buttonUrl={card.buttonUrl}
                                    key={card.title}
                                />
                            );
                        }
                    })}
                </Carousel>
            </>
        );
    },
);

DashboardMarketingCardUi.displayName = 'DashboardMarketingCardUi';
